import React, { forwardRef } from 'react';

type TBtnTheme = 'teal';
type TBtnSize = 's';

interface IBtnDisplay {
  size: TBtnSize;
  theme: TBtnTheme;
  hasOutline?: boolean;
  isFullHeight?: boolean;
  isFullWidth?: boolean;
}

export interface IBtnProps {
  children: React.ReactNode;
  display: IBtnDisplay;
  ariaLabel?: string;
  disabled?: boolean;
  onClick: (event: React.MouseEvent) => void;
}

const Btn = forwardRef<HTMLButtonElement, IBtnProps>(
  (
    {
      children,
      display: {
        size,
        theme,
        hasOutline = false,
        isFullHeight = false,
        isFullWidth = false,
      },
      ariaLabel,
      disabled = false,
      onClick,
    },
    ref
  ) => {
    const classes = [`has-bg-${theme}`, `c-button--${size}`];

    if (hasOutline) {
      classes.push('c-button--outline');
      classes.push(`has-text-${theme}`);
      classes.push(`has-text-hover-${theme}`);
      classes.push('has-reset-padding');
    }

    if (isFullWidth) {
      classes.push('l-width-full');
    }

    if (isFullHeight) {
      classes.push('l-height-full');
    }

    return (
      <button
        aria-label={ariaLabel}
        className={`c-button l-align-center-children ${classes.join(' ')}`}
        disabled={disabled}
        onClick={onClick}
        ref={ref}
        type="button"
      >
        <span className="c-button__inner">{children}</span>
      </button>
    );
  }
);

export default Btn;
